export const FETCH_NUTRITION_PROGREAMS = "FETCH_NUTRITION_PROGREAMS";
export const SET_NUTRITION_PROGRAM = "SET_NUTRITION_PROGRAM";
export const ERROR_NUTRITION_PROGRAM = "ERROR_NUTRITION_PROGRAM";

export const SET_TRAINING_PROGRAM = "SET_TRAINING_PROGRAM";
export const ERROR_TRAINING_PROGRAM = "ERROR_TRAINING_PROGRAM";
